// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Plantilla_remito__Wmxyf {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ {
  height: 260px;
  margin: 10px;
  border: 2px solid rgba(128, 128, 128, 0.48);
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_imageContainer__BsehQ {
  height: 100%;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_image__JNNjw {
  width: 100%;
  height: 160px;
  display: flex;
  object-fit: fit;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_image__JNNjw span {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ p {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_image__JNNjw img {
  width: 100%;
  height: 85%;
  object-fit: scale-down;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_label__EVKj2 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60%;
  font-size: 48px;
  font-family: Roboto, sans-serif;
  font-weight: 800;
  border-radius: 0 0 15px 15px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_title__SFS3j,
.Plantilla_title2__bk\\+in,
.Plantilla_dates__\\+yR96 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 90%;
  font-size: 0.8rem;
  padding-left: 5px;
  border-radius: 5px;
  margin-top: 30px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_title__SFS3j p {
  font-size: 30px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_title2__bk\\+in p {
  font-size: 28px;
  font-weight: 400;
  font-family: Roboto, sans-serif;
}
.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_title__SFS3j span {
  font-size: 16px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_dates__\\+yR96 {
  width: 90%;
  margin-top: 10px;
  padding-left: 0;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_date__qv0QT {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  height: 100%;
  border-radius: 5px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_box__WP06z {
  border: 1px solid rgba(128, 128, 128, 0.55);
  margin-left: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_box__WP06z p {
  font-size: 24px;
  font-weight: 500;
  font-family: Roboto, sans-serif;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_data__N0kB5 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 90%;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 24px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N .Plantilla_data__N0kB5 p {
  font-size: 18px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_header__9HPY\\+ .Plantilla_headerData__OGT3N p {
  font-size: 0.8rem;
  margin: 5px 16px 0 0;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_client__wD-pP {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 10px 10px;
  border: 2px solid rgba(128, 128, 128, 0.48);
  background-color: rgba(174, 174, 174, 0.51);
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_client__wD-pP .Plantilla_h4__qYqaq {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  padding-inline: 10px;
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.Plantilla_remito__Wmxyf .Plantilla_client__wD-pP .Plantilla_check__XPRz7 {
  background-color: white;
  width: 30px;
  height: 30px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_client__wD-pP h2 {
  font-size: 1rem;
  font-weight: 600;
  margin-left: 10px;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_client__wD-pP p {
  font-size: 0.8rem;
}

.Plantilla_remito__Wmxyf .Plantilla_canvas__C5Nnw .Plantilla_client__wD-pP .Plantilla_dataClient__WXiOb {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  margin-left: 10px;
}

.Plantilla_remito__Wmxyf .Plantilla_details__y3Ay- {
  border: 2px solid rgba(128, 128, 128, 0.48);
  margin: 0 10px 10px;
}

.Plantilla_remito__Wmxyf .Plantilla_observations__VKnF6,
.Plantilla_cai__2thVx {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgba(128, 128, 128, 0.48);
  margin: 0 10px 10px;
}

.Plantilla_remito__Wmxyf .Plantilla_cai__2thVx {
  display: flex;
  justify-content: space-between;
  margin-inline: 10px;
  align-items: flex-end;
}

.Plantilla_remito__Wmxyf .Plantilla_cai__2thVx h2 {
  padding-inline: 10px;
  font-size: 16px;
  font-weight: 300;
}

.Plantilla_remito__Wmxyf .Plantilla_observations__VKnF6 .Plantilla_text__FDQso {
  text-align: start;
  margin-top: 10px;
  line-height: 50px;
}

.Plantilla_remito__Wmxyf .Plantilla_observations__VKnF6 .Plantilla_sign__whWgS {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Impreso/Plantilla.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".remito {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.remito .canvas {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.remito .canvas .header {\n  height: 260px;\n  margin: 10px;\n  border: 2px solid rgba(128, 128, 128, 0.48);\n}\n\n.remito .canvas .header .imageContainer {\n  height: 100%;\n}\n\n.remito .canvas .header .image {\n  width: 100%;\n  height: 160px;\n  display: flex;\n  object-fit: fit;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.remito .canvas .header .image span {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.remito .canvas .header p {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.remito .canvas .header .image img {\n  width: 100%;\n  height: 85%;\n  object-fit: scale-down;\n}\n\n.remito .canvas .header .label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60%;\n  font-size: 48px;\n  font-family: Roboto, sans-serif;\n  font-weight: 800;\n  border-radius: 0 0 15px 15px;\n}\n\n.remito .canvas .header .headerData {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n}\n\n.remito .canvas .header .headerData .title,\n.title2,\n.dates {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 90%;\n  font-size: 0.8rem;\n  padding-left: 5px;\n  border-radius: 5px;\n  margin-top: 30px;\n}\n\n.remito .canvas .header .headerData .title p {\n  font-size: 30px;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n}\n\n.remito .canvas .header .headerData .title2 p {\n  font-size: 28px;\n  font-weight: 400;\n  font-family: Roboto, sans-serif;\n}\n.remito .canvas .header .headerData .title span {\n  font-size: 16px;\n}\n\n.remito .canvas .header .headerData .dates {\n  width: 90%;\n  margin-top: 10px;\n  padding-left: 0;\n}\n\n.remito .canvas .header .headerData .date {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.2rem;\n  height: 100%;\n  border-radius: 5px;\n}\n\n.remito .canvas .header .headerData .box {\n  border: 1px solid rgba(128, 128, 128, 0.55);\n  margin-left: 10px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.remito .canvas .header .headerData .box p {\n  font-size: 24px;\n  font-weight: 500;\n  font-family: Roboto, sans-serif;\n}\n\n.remito .canvas .header .headerData .data {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width: 90%;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  font-size: 24px;\n}\n\n.remito .canvas .header .headerData .data p {\n  font-size: 18px;\n}\n\n.remito .canvas .header .headerData p {\n  font-size: 0.8rem;\n  margin: 5px 16px 0 0;\n}\n\n.remito .canvas .client {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 0 10px 10px;\n  border: 2px solid rgba(128, 128, 128, 0.48);\n  background-color: rgba(174, 174, 174, 0.51);\n}\n\n.remito .canvas .client .h4 {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  width: 100%;\n  padding-inline: 10px;\n  text-align: center;\n  font-size: 1rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.remito .client .check {\n  background-color: white;\n  width: 30px;\n  height: 30px;\n}\n\n.remito .canvas .client h2 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-left: 10px;\n}\n\n.remito .canvas .client p {\n  font-size: 0.8rem;\n}\n\n.remito .canvas .client .dataClient {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n  margin-left: 10px;\n}\n\n.remito .details {\n  border: 2px solid rgba(128, 128, 128, 0.48);\n  margin: 0 10px 10px;\n}\n\n.remito .observations,\n.cai {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid rgba(128, 128, 128, 0.48);\n  margin: 0 10px 10px;\n}\n\n.remito .cai {\n  display: flex;\n  justify-content: space-between;\n  margin-inline: 10px;\n  align-items: flex-end;\n}\n\n.remito .cai h2 {\n  padding-inline: 10px;\n  font-size: 16px;\n  font-weight: 300;\n}\n\n.remito .observations .text {\n  text-align: start;\n  margin-top: 10px;\n  line-height: 50px;\n}\n\n.remito .observations .sign {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"remito": `Plantilla_remito__Wmxyf`,
	"canvas": `Plantilla_canvas__C5Nnw`,
	"header": `Plantilla_header__9HPY+`,
	"imageContainer": `Plantilla_imageContainer__BsehQ`,
	"image": `Plantilla_image__JNNjw`,
	"label": `Plantilla_label__EVKj2`,
	"headerData": `Plantilla_headerData__OGT3N`,
	"title": `Plantilla_title__SFS3j`,
	"title2": `Plantilla_title2__bk+in`,
	"dates": `Plantilla_dates__+yR96`,
	"date": `Plantilla_date__qv0QT`,
	"box": `Plantilla_box__WP06z`,
	"data": `Plantilla_data__N0kB5`,
	"client": `Plantilla_client__wD-pP`,
	"h4": `Plantilla_h4__qYqaq`,
	"check": `Plantilla_check__XPRz7`,
	"dataClient": `Plantilla_dataClient__WXiOb`,
	"details": `Plantilla_details__y3Ay-`,
	"observations": `Plantilla_observations__VKnF6`,
	"cai": `Plantilla_cai__2thVx`,
	"text": `Plantilla_text__FDQso`,
	"sign": `Plantilla_sign__whWgS`
};
export default ___CSS_LOADER_EXPORT___;
